export default __webpack_public_path__ + "static/media/chacha.6884db0c.jpg";